import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoot from './App';
import { PrimeReactProvider } from 'primereact/api';
import { twMerge } from 'tailwind-merge';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './adgtheme/themes/adg/theme.scss';

ReactDOM.createRoot(document.getElementById('root')).render(
  <PrimeReactProvider
    value={{
      // unstyled: false,
      pt: {},
      ptOptions: {
        mergeSections: true,
        mergeProps: true,
        classNameMergeFunction: twMerge,
      },
    }}
  >
    <BrowserRouter>
      <AppRoot />
    </BrowserRouter>
  </PrimeReactProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
